/**
 * Add router specific hooks to class components:
 *  - beforeRouteEnter
 *  - beforeRouteLeave
 *  - beforeRouteUpdate
 */

// class-component-hooks.js
import Component from 'vue-class-component'

// Register the router hooks with their names
Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
  // for vue-router 2.2+
  'beforeRouteUpdate',
  // Vuelidate
  'validations',
  // provide
  'provide',
])
